import _ from "lodash";

export const toTitleCase = (str?: string) => _.upperFirst(_.lowerCase(str));

export const containsSubstringCaseInsensitive = (str: string, substr: string) =>
    str.toLocaleLowerCase().includes(substr.toLocaleLowerCase());
